import React from "react";

const HowDoIKnow = (props: any) => {
    return (
        <div>
            <div>Warning signs that might indicate your child’s/dependent’s identity has been stolen can include, but are not limited to:</div>
            <ul>
                <li>
                    <div className="row">
                        <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                            <p>
                                <strong>&#x2022;</strong>
                            </p>
                        </div>
                        <div className={"col-xs-11"}>
                            <p>
                                Your child/dependent begins to receive suspicious mail, like pre-approved credit cards and other financial offers normally sent to
                                adults, in the child's/dependent's name.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="row">
                        <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                            <p>
                                <strong>&#x2022;</strong>
                            </p>
                        </div>
                        <div className={"col-xs-11"}>
                            <p>
                                A credit file already exists in the child's/children's name. If the child/dependent has one, they may have been targeted already,
                                since only an application for credit, a credit account, or a public record starts the compilation of a consumer credit file.
                            </p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default HowDoIKnow;
